module.exports = __webpack_public_path__ + "img/Bots-icon.17a7b031.svg";